import { formatMultilineAddress as formatAddress } from '@wix/form-multiline-address';
export function formatMultilineAddress(submission, t, language) {
  return formatAddress(submission, {
    translateCountry: (key, lng) => t(key, {
      lng
    }),
    language
  });
}
//# sourceMappingURL=format-multiline-address.js.map